(function () {
    'use strict';

    var module = angular.module('uwAgenda.website');
    module.directive('websiteGeneratorIncludedItems', [ websiteGeneratorIncludedItemsFn]);

    // filter directive for multiple shared agenda selection
    function websiteGeneratorIncludedItemsFn() {
        
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/website-generator/templates/website-generator-included-items.template.html',
            scope: {
                labels: '=',
                users: '='
            }
            
        };
        return directive;
        function link(scope, element, attrs) {
            scope.filterCollapsed = false;            
        } // link
    }
})();